'use client';

import { useEffect } from 'react';

const GTM_ID = 'GTM-N95T29H';

export default function DeferredGtm() {
  useEffect(() => {
    let loaded = false;
    let timerId;

    const loadGtm = () => {
      if (loaded) return;
      loaded = true;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
      });

      const firstScript = document.getElementsByTagName('script')[0];
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
      firstScript.parentNode.insertBefore(script, firstScript);
    };

    const scheduleGtm = () => {
      timerId = window.setTimeout(loadGtm, 12000);
    };

    const interactionEvents = ['pointerdown', 'keydown', 'scroll'];
    interactionEvents.forEach((eventName) => {
      window.addEventListener(eventName, loadGtm, { once: true, passive: true });
    });

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(scheduleGtm, { timeout: 8000 });
    } else {
      scheduleGtm();
    }

    return () => {
      if (timerId) window.clearTimeout(timerId);
      interactionEvents.forEach((eventName) => {
        window.removeEventListener(eventName, loadGtm);
      });
    };
  }, []);

  return null;
}
